
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/share/affiliate-list/[id]",
      function () {
        return require("private-next-pages/share/affiliate-list/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/share/affiliate-list/[id]"])
      });
    }
  